import { GET_ADDBOOKING, GET_BOOKINGDETAILS, GET_BOOKINGLIST, GET_CANCELREASSON, GET_BOOKINGBUFFERTIME, GET_UPDATEBOOKING, GET_COMPANYCITY, GET_COMPANYSERVICE, GET_AIRPORTTERMINALLIST } from "resources/actionTypes";

export function getBookingList(payloadData) {
  
  return {
    type: GET_BOOKINGLIST.GET_BOOKINGLIST_REQUESTED,
    payload: payloadData
  };
}

export function getBookingDetails(payloadData) {
  
  return {
    type: GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_REQUESTED,
    payload: payloadData
  };
}

export function clearBookingDetails() {
  return {
    type: GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_RESET,
  };
}

export function addBooking(bookingData, toggle) {

  const data = {
    bookingData: bookingData,
    setConfirmModal: toggle
  }
  
  return {
    type: GET_ADDBOOKING.GET_ADDBOOKING_REQUESTED,
    payload: data
  };
}

export function updateBooking(tripId, bookingData, navigate) {

  const data = {
    tripId: tripId,
    bookingData: bookingData,
    navigate: navigate
  }
  
  return {
    type: GET_UPDATEBOOKING.GET_UPDATEBOOKING_REQUESTED,
    payload: data
  };
}

export function getCancelReason(payloadData) {
  
  return {
    type: GET_CANCELREASSON.GET_CANCELREASSON_REQUESTED,
    payload: payloadData
  };
}

export function getBookingBufferTime(payloadData) {
  
  return {
    type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED,
    payload: payloadData
  }
}

export function getCompanyCity(payloadData) {
  
  return {
    type: GET_COMPANYCITY.GET_COMPANYCITY_REQUESTED,
    payload: payloadData
  }
}

export function getCompanyService(data, type, setFilterValues, filterValues) {
  
  const payloadData = {
    data: data, 
    type: type,
    setFilterValues: setFilterValues,
    filterValues: filterValues
  }
  
  return {
    type: GET_COMPANYSERVICE.GET_COMPANYSERVICE_REQUESTED,
    payload: payloadData
    }
}

export function getAirportTerminalList(payloadData) {
  return {
    type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED,
    payload: payloadData
  }
}